export const ENV = {
  API_URL: process.env.REACT_APP_API_URL,
  ENVIRONMENT_SUFFIX: process.env.REACT_APP_ENVIRONMENT_SUFFIX,
};
